export const staticPaths = {
  home: '/',
  about: '/about',
  blog: '/blog',
  work: '/work',
  acceligent: '/work/management-solution-for-construction', // case studies pages are not dynamically created
  audubon: '/work/bird-species-identifying-app',
  squadlocker: '/work/custom-apparel-fulfillment-solution',
  qant: '/work/football',
  learnRAG: '/work/enterprise-rag-ai-solutions',
  pista: '/work/pista-precision-racing-mobile-platform',
  contact: '/contact',
  cookiePolicy: '/cookie-policy',
  privacyPolicy: '/privacy-policy',
  careers: '/careers',
  open_application: '/careers/open-application',
  eu_project: '/eu-project',
}

export const dynamicPaths = {
  blogPost: (slug: string): string => `/blog/${slug}`,
  careersPosition: (slug: string): string => `/careers/${slug}`,
  businessCard: (slug: string): string => `/card/${slug}`,
}

export default {
  ...staticPaths,
  ...dynamicPaths,
}
